export default __webpack_public_path__ + "static/media/false_cieling.fef42983.jpg";